import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { ReserviertAntwort } from '@/types/reserviert';

/**
 * „Ist dieses Exemplar für jemanden reserviert?" (#59, A27)
 *
 * `enabled` erst ab drei Zeichen: darunter weist der Server ohnehin ab,
 * und eine Fehlermeldung während des Tippens ist keine Auskunft.
 *
 * `staleTime` 0: Die Frage lautet „ist es JETZT reserviert". Eine
 * Antwort aus dem Zwischenspeicher wäre hier die falsche Art von
 * schnell — zwischen zwei Fragen kann jemand anders gebucht haben.
 */
export function useReserviert(begriff: string) {
  const sauber = begriff.trim();
  return useQuery({
    queryKey: ['reserviert', sauber],
    queryFn: () => apiFetch<ReserviertAntwort>(`/reserviert.php?q=${encodeURIComponent(sauber)}`),
    enabled: sauber.length >= 3,
    staleTime: 0,
    gcTime: 0
  });
}
